import { render } from "./Coin.vue?vue&type=template&id=0c15abed"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"

import "./Coin.vue?vue&type=style&index=0&id=0c15abed&lang=css"
script.render = render

export default script